import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonMigFormComponent } from '../../components/abstract/common-mig-form.component';
import { MigFormData } from '@models/forms/mig-form-data.model';

@Component({
  selector: 'app-congratulations-page',
  templateUrl: './congratulations-page.component.html',
  styleUrls: ['./congratulations-page.component.scss'],
})
export class CongratulationsPageComponent
  extends CommonMigFormComponent
  implements OnDestroy
{
  migFormData: MigFormData | null = null;

  constructor() {
    super();
    this.migFormData = this.module.storage;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    //this.module.clearStorage();
  }
}
